import { render, staticRenderFns } from "./StageListNav.vue?vue&type=template&id=0bf2082d&scoped=true&lang=pug&"
import script from "./StageListNav.vue?vue&type=script&lang=js&"
export * from "./StageListNav.vue?vue&type=script&lang=js&"
import style0 from "./StageListNav.vue?vue&type=style&index=0&id=0bf2082d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf2082d",
  null
  
)

export default component.exports